import apiInstance from "@services/Shared/instanceAxios";

const deleteUser = (id: string) =>
  apiInstance({
    url: `/users/${id}`,
    method: "delete",
  });

export default deleteUser;
